const STORAGE_KEY = "medisys_cart_attached_prescriptions";

const getAuthToken = () => {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem("authToken");
  } catch {
    return null;
  }
};

// Scope the saved selection to the current login without storing another copy
// of the authentication token in localStorage.
const fingerprintToken = (token) => {
  let hash = 2166136261;
  for (let index = 0; index < token.length; index += 1) {
    hash ^= token.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(36);
};

const normalizePrescriptions = (prescriptions) => {
  if (!Array.isArray(prescriptions)) return [];

  const seen = new Set();
  return prescriptions.reduce((result, prescription) => {
    const prescriptionId = prescription?.prescription_id;
    if (
      prescriptionId === null ||
      prescriptionId === undefined ||
      seen.has(String(prescriptionId))
    ) {
      return result;
    }

    seen.add(String(prescriptionId));
    result.push({
      prescription_id: prescriptionId,
      image_url:
        typeof prescription.image_url === "string"
          ? prescription.image_url
          : null,
    });
    return result;
  }, []);
};

export const loadCartPrescriptions = () => {
  const token = getAuthToken();
  if (!token) return [];

  try {
    const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    if (saved?.owner !== fingerprintToken(token)) return [];
    return normalizePrescriptions(saved.prescriptions);
  } catch {
    return [];
  }
};

export const saveCartPrescriptions = (prescriptions) => {
  if (typeof window === "undefined") return;

  const token = getAuthToken();
  const normalized = normalizePrescriptions(prescriptions);
  try {
    if (!token || normalized.length === 0) {
      window.localStorage.removeItem(STORAGE_KEY);
      return;
    }

    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        owner: fingerprintToken(token),
        prescriptions: normalized,
      }),
    );
  } catch {}
};

export const clearCartPrescriptions = () => {
  if (typeof window !== "undefined") {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch {}
  }
};
